import React from 'react';
import { BarChart, Eye, TrendingUp, Info } from 'lucide-react';

/**
 * Секция с настройками отслеживания
 */
const TrackingSection = ({ formData, handleInputChange, errors }) => {
  // Если нет настроек отслеживания, показываем минимальный интерфейс
  if (!formData.includeGoogleAnalytics && !formData.useUtmParameters) {
    return null;
  }

  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-100 dark:border-amber-800">
      <h3 className="text-lg font-semibold text-amber-800 dark:text-amber-300 mb-4 flex items-center">
        <BarChart className="w-5 h-5 mr-2 text-amber-500" />
        Настройки отслеживания
      </h3>
      
      {/* Информационный блок */}
      <div className="bg-white dark:bg-gray-800 p-3 rounded mb-4 border border-amber-100 dark:border-amber-800 flex items-start">
        <Info className="w-5 h-5 text-amber-500 mr-3 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-gray-700 dark:text-gray-300">
          <p className="font-medium mb-1">Для чего нужно отслеживание?</p>
          <p>Добавление меток отслеживания позволяет анализировать эффективность email-маркетинга: 
            количество открытий писем, переходы по ссылкам и другие метрики. UTM-метки будут 
            отображаться в вашей системе аналитики (Google Analytics, Яндекс.Метрика и др.).</p>
        </div>
      </div>

      {/* Настройки UTM */}
      {formData.useUtmParameters && (
        <div className="mb-4">
          <h4 className="text-base font-medium text-amber-700 dark:text-amber-300 mb-2 flex items-center">
            <TrendingUp className="w-4 h-4 mr-2" />
            Настройка UTM-меток
          </h4>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label htmlFor="utmSource" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Источник
              </label>
              <input
                type="text"
                id="utmSource"
                name="utmSource"
                value={formData.utmSource}
                onChange={handleInputChange}
                className="form-input"
              />
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                utm_source
              </p>
            </div>
            
            <div>
              <label htmlFor="utmMedium" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Тип трафика
              </label>
              <input
                type="text"
                id="utmMedium"
                name="utmMedium"
                value={formData.utmMedium}
                onChange={handleInputChange}
                className="form-input"
              />
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                utm_medium
              </p>
            </div>
            
            <div>
              <label htmlFor="utmCampaign" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Кампания
              </label>
              <input
                type="text"
                id="utmCampaign"
                name="utmCampaign"
                value={formData.utmCampaign}
                onChange={handleInputChange}
                className={`form-input ${errors.utmCampaign ? 'input-error' : ''}`}
              />
              {errors.utmCampaign && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.utmCampaign}
                </p>
              )}
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                utm_campaign
              </p>
            </div>
          </div>
        </div>
      )}
      
      {/* Настройки Google Analytics */}
      {formData.includeGoogleAnalytics && (
        <div>
          <h4 className="text-base font-medium text-amber-700 dark:text-amber-300 mb-2 flex items-center">
            <Eye className="w-4 h-4 mr-2" />
            Отслеживание через Google Analytics
          </h4>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="gaTrackingId" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Tracking ID
              </label>
              <input
                type="text"
                id="gaTrackingId"
                name="gaTrackingId"
                value={formData.gaTrackingId}
                onChange={handleInputChange}
                placeholder="UA-XXXXXXXX-X или G-XXXXXXXXXX"
                className={`form-input ${errors.gaTrackingId ? 'input-error' : ''}`}
              />
              {errors.gaTrackingId && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.gaTrackingId}
                </p>
              )}
            </div>
            
            <div className="flex items-center">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  name="trackOpens"
                  checked={formData.trackOpens}
                  onChange={handleInputChange}
                  className="form-checkbox"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  Отслеживать открытия письма
                </span>
              </label>
            </div>
          </div>
          
          <p className="mt-2 text-xs text-amber-600 dark:text-amber-400">
            <strong>Важно:</strong> Для корректной работы отслеживания открытия писем, в клиенте 
            электронной почты должно быть включено отображение изображений.
          </p>
        </div>
      )}
    </div>
  );
};

export default TrackingSection;